module.exports = __webpack_public_path__ + "img/tablet-neck-8_532x18.8f9535cc.png";